import { Button } from 'src/components/atoms';
import styled from 'styled-components';

export const StyledBackButton = styled(Button)`
  min-width: auto;
`;
